(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusAssessInitiativesListController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'govProcess', 'initAssessmentsByAssessor', 'notificationService'];

    function Controller($scope, $state, topBarService, govProcess, initAssessmentsByAssessor, notificationService) {

        if ($state.is('initiativeUpdateStatusAssess.initiatives.assess')) {
            var areAllInitiativesNotAssessed = _.every(initAssessmentsByAssessor, { PlanInitiativeAssessment: { IsLocked: false } });
            var initiativeToAssess = _.find(initAssessmentsByAssessor, { PlanInitiativeAssessment: {IsLocked: false }});

            if (areAllInitiativesNotAssessed) {
                $state.go('initiativeUpdateStatusAssess.initiatives.assess.welcome', {}, { location: 'replace' });
                return;
            }

            if (!_.isUndefined(initiativeToAssess)) {
                $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverables',
                    { PlanInitiativeID: initiativeToAssess.PlanInitiative.PlanInitiativeID },
                    { location: 'replace' });
                return;
            }

            $state.go('initiativeUpdateStatusAssess.initiatives.assess.completed', {}, { location: 'replace' });

            return;
        }

        topBarService.setTitleAndIcon('Business Planning', 'fa fa-compass');
        $scope.govProcess = govProcess;


        $scope.canEdit = false;
        if ($scope.assessmentByInitiative && $scope.assessmentByInitiative.PlanInitiative) {
            $scope.canEdit = $scope.assessmentByInitiative.PlanInitiative.IsOwner || $scope.assessmentByInitiative.PlanInitiative.IsOwnerDelegate;
        }

        // Go To First Initiative To Assess
        $scope.goToFirstInitiativeToAssess = function () {
            if (!initAssessmentsByAssessor.length) {
                notificationService.warn('No assessment available');
                return;
            }

            var initiativeToAssess = _.find(initAssessmentsByAssessor, { PlanInitiativeAssessment: { IsSubmitted: false } });

            $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverables',
                        { PlanInitiativeID: initiativeToAssess.PlanInitiative.PlanInitiativeID });
        };
    }
})();